import dayjs from 'dayjs';

const DEFAULT_DATE_FORMAT = 'DD/MM/YYYY';
const DEFAULT_DATE_TIME_FORMAT = 'DD/MM/YYYY HH:mm';

export const date = (value, format = DEFAULT_DATE_FORMAT) => {
  if (!value) return '';
  return dayjs(value).format(format);
};

export const dateTime = (value, format = DEFAULT_DATE_TIME_FORMAT) => {
  if (!value) return '';
  return dayjs(value).format(format);
};
